<template>
  <div>
    <NavbarTwo />
    <div class="static-hero">
      <div class="container mw-1356">
        <span class="top-title">LEGAL</span>
        <h1>Privacy Policy</h1>
        <p>How we collect, use, and protect your information</p>
      </div>
    </div>
    <div class="static-body bg-gondola">
      <div class="container mw-1356" style="max-width:860px">
        <div class="pp-section">
          <h2>1. Information We Collect</h2>
          <p>When you create an account we collect your name, email address, and optionally your phone number. When you subscribe to a plan we record payment confirmation details (not full card numbers). We also log IP addresses and browser information for security purposes.</p>
        </div>
        <div class="pp-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain your IPTV subscription</li>
            <li>To send you your streaming credentials and account notifications</li>
            <li>To respond to support inquiries</li>
            <li>To improve our service and troubleshoot issues</li>
          </ul>
        </div>
        <div class="pp-section">
          <h2>3. Data Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist us in operating our platform, subject to confidentiality agreements.</p>
        </div>
        <div class="pp-section">
          <h2>4. Data Retention</h2>
          <p>We retain your account data for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data by contacting us.</p>
        </div>
        <div class="pp-section">
          <h2>5. Cookies</h2>
          <p>We use essential cookies to keep you logged in and remember your preferences. No third-party advertising cookies are used.</p>
        </div>
        <div class="pp-section">
          <h2>6. Security</h2>
          <p>We implement industry-standard security measures including encrypted connections (HTTPS) and hashed passwords. No method of transmission over the internet is 100% secure, but we strive to protect your information.</p>
        </div>
        <div class="pp-section">
          <h2>7. Payment Card Security</h2>
          <p>We do <strong>not</strong> collect, process or store your full card number, CVV or expiry date on our servers. When you pay by card, your card details are transmitted over an encrypted (TLS) connection directly to our PCI-DSS compliant payment facilitator, {{ c.payments.facilitator.name }}, who processes the transaction. We only receive a confirmation of payment and a reference — never your raw card data.<template v-if="c.payments.descriptor"> Charges appear on your statement as <strong>{{ c.payments.descriptor }}</strong>.</template></p>
        </div>
        <div class="pp-section">
          <h2>8. Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data. To exercise these rights, please contact us through our <RouterLink to="/contact-us">contact page</RouterLink>.</p>
        </div>
        <div class="pp-section">
          <h2>9. Changes to This Policy</h2>
          <p>We may update this policy from time to time. We will notify registered users of significant changes via email. Continued use of the service after changes constitutes acceptance.</p>
        </div>
        <div class="pp-section">
          <h2>10. Data Controller &amp; Contact</h2>
          <p>
            The data controller is {{ c.legalName }}, {{ address }}.<br />
            <span v-if="c.support.email">Email: <a :href="'mailto:' + c.support.email">{{ c.support.email }}</a><br /></span>
            For privacy-related questions, please reach us via our <RouterLink to="/contact-us">Contact Us</RouterLink> page.
          </p>
        </div>
      </div>
    </div>
    <CopyRight />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";
import { company, establishmentLine } from "@/config/company";

export default defineComponent({
  name: "PrivacyPolicyPage",
  components: { NavbarTwo, CopyRight },
  setup() {
    return { c: company, address: establishmentLine() };
  },
});
</script>

<style scoped>
.static-hero {
  background: linear-gradient(135deg, #1a0a0b 0%, #2d1214 100%);
  padding: 120px 0 60px;
  text-align: center;
}
.static-hero .top-title {
  display: inline-block;
  background: rgba(201,14,14,0.15);
  color: #e84749;
  border: 1px solid rgba(201,14,14,0.3);
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 1rem;
}
.static-hero h1 {
  color: #fff;
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 900;
  margin-bottom: 0.75rem;
}
.static-hero p {
  color: #c0c0c0;
  font-size: 1.1rem;
}
.static-body {
  padding: 80px 0 100px;
}
.bg-gondola { background: #120a0b; }
.pp-section {
  margin-bottom: 2.5rem;
}
.pp-section h2 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #2d1214;
}
.pp-section p,
.pp-section li {
  color: #c0c0c0;
  line-height: 1.8;
  font-size: 0.95rem;
}
.pp-section ul {
  padding-left: 1.5rem;
}
.pp-section ul li {
  margin-bottom: 0.4rem;
}
.pp-section a {
  color: #e84749;
  text-decoration: none;
}
.pp-section a:hover { text-decoration: underline; }
</style>
